// root '../../../';

// dependencies
import { Child } from 'pym.js';
import { select } from 'd3-selection';

// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils & graphic
import config from './config';
import graphic from './graphic';

// styles
import './styles/index.scss';

/* develblock:start */
import meta from './data/meta.json';

const pkg = require('../package.json');

const DATA_URL = 'https://ix.cnn.io/data/ice-tracker/trac_bookins.json';

// Cache for fetched data
let cachedData = null;
let footnoteText = null;

async function fetchData() {
  if (cachedData) return { data: cachedData, footnoteText };
  const response = await fetch(DATA_URL);
  const text = await response.text();
  // Replace NaN with null to make valid JSON
  const sanitized = text.replace(/:\s*NaN/g, ': null');
  const json = JSON.parse(sanitized);

  footnoteText = json.lastUpdatedStr;

  // json.lastUpdated is the ISO timestamp (e.g. "2026-04-04T00:00:00")
  // Build the first day of that month as a YYYY-MM-DD string (e.g. "2026-04-01").
  // Filtering d.date < that string keeps all data through the last day of the
  // previous (complete) month — e.g. everything through 2026-03-31.
  const ts = new Date(json.lastUpdated);
  const currentMonthStart = `${ts.getFullYear()}-${String(ts.getMonth() + 1).padStart(2, '0')}-01`;

  cachedData = json.data.filter(d => d.authority !== 'total'
    && d.bookins != null
    && d.bookins > 0
    && d.date < currentMonthStart);
  return { data: cachedData, footnoteText };
}

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw, id: pkg.name });

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();
};

async function draw(initialWidth) {
  const container = select('#graphic');
  container.html('');

  const fallbackWidth = container.node().clientWidth || 600;
  const safeWidth = initialWidth !== fallbackWidth ? fallbackWidth : initialWidth;
  const isMobile = safeWidth <= 500;

  const heightMultiplier = isMobile ? 1 : 9 / 16;
  const initialHeight = heightMultiplier * safeWidth;

  const { data: raw, footnoteText: updated } = await fetchData();

  // Update footnote with last updated display string
  const footnote = document.querySelector('.footnote');
  if (footnote && updated) {
    footnote.innerHTML = `Data last updated ${updated}`;
  }

  const props = {
    initialWidth: safeWidth, initialHeight, isMobile, raw,
  };

  const graphicConfig = config(props);
  graphic(graphicConfig, container, isMobile);

  // Send height after graphic is rendered
  window.pymChild.sendHeight();
}
